import { Icon, IIconProps } from 'native-base';
import { Path } from 'react-native-svg';

export const ThumbsUpIcon = ({ size = 'sm', ...props }: IIconProps) => {
  return (
    <Icon size={size} viewBox="0 0 24 25" fill="none" {...props}>
      <Path
        d="M7.40918 22V11M2.40918 13V20C2.40918 21.1046 3.30461 22 4.40918 22H17.8354C19.3161 22 20.5754 20.9197 20.8005 19.4562L21.8775 12.4562C22.157 10.6389 20.751 9 18.9123 9H15.4092C14.8569 9 14.4092 8.55228 14.4092 8V4.46584C14.4092 3.10399 13.3052 2 11.9433 2C11.6185 2 11.3242 2.1913 11.1922 2.48812L7.67312 10.4061C7.51262 10.7673 7.1545 11 6.75931 11H4.40918C3.30461 11 2.40918 11.8954 2.40918 13Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </Icon>
  );
};
